export default __webpack_public_path__ + "static/SSSpyView_screenshot-5@2x-6da16267f6f47fe184c43a8dc82a92cf.jpg";